export const TERMS_OF_USE = (
  <>
    <p><strong>עדכון אחרון: {new Date().toLocaleDateString('he-IL')}</strong></p>
    <p>ברוכים הבאים לאתר אורבניקס (ai.urbanix) ולשירותי יועץ הנדל"ן-AI שלנו (להלן יחד: "השירות").</p>
    <p>השימוש באתר ובשירות כפוף לתנאי שימוש אלה (להלן: "התנאים"). אנא קרא/י אותם בעיון לפני השימוש.</p>
    <p>על ידי כניסה לאתר, גלישה בו, שימוש בכלי ניתוח, קבלת דוחות או הרשמה לשירות – אתה מאשר/ת שקראת את התנאים, הבנת אותם, ואת/ה מסכים/ה להם. אם אינך מסכים/ה – אנא הימנע/י משימוש באתר.</p>
    <p>הבהרה חשובה: תנאים אלה הם טיוטה כללית ואינם מהווים ייעוץ משפטי. לפני אימוצם הסופי מומלץ להיוועץ בעו״ד.</p>

    <h3>1. הגדרות</h3>
    <p>בתנאים אלה:</p>
    <ul>
      <li>"החברה" / "אנחנו" / "אורבניקס" – מפעילי האתר והשירות ai.urbanix.</li>
      <li>"האתר" – כל הדפים, התכנים, הקבצים והממשקים בכתובת ai.urbanix וכל כתובת אחרת שאליה נפנה.</li>
      <li>"השירות" – לרבות כל כלי, דוח, ניתוח, שכבת נתונים, שירות AI, ממשק מפה, חומרי מידע ותוכן אחר הניתן באמצעות האתר.</li>
      <li>"משתמש" / "אתה" – כל אדם או גוף המשתמש באתר או בשירות, לרבות ללא הרשמה.</li>
    </ul>

    <h3>2. תיאור השירות</h3>
    <p>אורבניקס היא פלטפורמת מידע וניתוח נדל"ני שמטרתה לרכז במקום אחד מידע מבוזר לגבי נכסים, חלקות וקרקעות בישראל, להנגיש אותו בצורה פשוטה ונהירה, ולספק שכבת "יועץ נדל"ן AI – "לרבות:</p>
    <ul>
      <li>הצגת נתונים סטטוטוריים, תכנוניים, עיסקיים וציבוריים;</li>
      <li>הפקת דוחות סטטיים ומתעדכנים (ממודולריים ועד תרחישים דינמיים);</li>
      <li>אינדיקציות לפוטנציאל התחדשות עירונית, "פליפ", שיפור נכס, שימושים אפשריים ועוד;</li>
      <li>ניתוחים, הערכות ו"המלצות" חכמות המבוססות על אלגוריתמים של בינה מלאכותית.</li>
    </ul>
    <p>השירות הוא שירות מידע וניטור בלבד, ואינו מהווה תחליף לייעוץ מקצועי פרטני מכל סוג.</p>

    <h3>3. אין ייעוץ משפטי / תכנוני / שמאי / פיננסי</h3>
    <p>המידע, הדוחות והתוצרים המופקים באתר:</p>
    <ul>
      <li>אינם מהווים ייעוץ משפטי, תכנוני, שמאי, פיננסי, מיסויי או השקעות;</li>
      <li>אינם מחליפים בדיקה רשמית במערכות התכנון, הרשויות המקומיות, שמאי מקרקעין, יועצים מקצועיים או כל גורם מוסמך אחר;</li>
      <li>עשויים להתבסס על נתונים ציבוריים/צד שלישי שאינם תמיד מעודכנים, מלאים או חפים מטעויות.</li>
    </ul>
    <p>לפני כל פעולה משפטית, תכנונית או פיננסית – עליך לפנות לאנשי מקצוע מוסמכים ולמידע הרשמי.</p>
    <p>אינך רשאי להסתמך אך ורק על השירות לצורך קבלת החלטות בעלות משמעות כלכלית/משפטית.</p>

    <h3>4. תנאי סף לשימוש</h3>
    <ul>
      <li>השימוש באתר מותר לגולשים בני 18 ומעלה בלבד.</li>
      <li>אתה מצהיר שהשימוש שלך בשירות נעשה לטובתך בלבד או בשם גוף שהסמיך אותך כדין.</li>
      <li>אתה מתחייב להשתמש בשירות בהתאם לדין הישראלי ולכל דין זר החל עליך, ובכפוף לתנאים אלו בלבד.</li>
    </ul>

    <h3>5. שימוש מותר ושימוש אסור</h3>
    <p><strong>5.1 שימוש מותר</strong></p>
    <p>מותר להשתמש באתר ובשירות לצורך:</p>
    <ul>
      <li>קבלת מידע וניתוח ראשוני על נכסים, חלקות וקרקעות;</li>
      <li>בחינת פוטנציאל כללי של פרויקטים נדל"ניים;</li>
      <li>קבלת אינדיקציות והכוונה ראשונית לפני פנייה לגורמים מקצועיים.</li>
    </ul>
    <p><strong>5.2 שימוש אסור</strong></p>
    <p>אסור:</p>
    <ul>
      <li>להשתמש בשירות לכל מטרה בלתי חוקית;</li>
      <li>להעתיק, לשכפל, לשאוב נתונים באופן שיטתי (Scraping) או להוריד מסדי נתונים ללא הרשאה מראש ובכתב;</li>
      <li>לעקוף, לשבש או לנסות לעקוף מנגנוני אבטחה, הגבלת גישה או כל טכנולוגיה המגינה על השירות;</li>
      <li>לבצע "הנדסה לאחור" של מערכות האתר, לרבות מודלי ה-AI;</li>
      <li>להשתמש בשירות לצורך ניתוח או יצירת מאגר מתחרה או לצורך מתן שירות מסחרי דומה ללא הסכמת החברה;</li>
      <li>להזין מידע שקרי, מטעה או שמפר זכויות של צדדים שלישיים (לרבות זכויות יוצרים, פרטיות וסודיות);</li>
      <li>להזין או להפיץ דרך השירות קוד זדוני, וירוסים, ספאם וכדומה.</li>
    </ul>
    <p>החברה רשאית, לפי שיקול דעתה, לחסום או להגביל משתמש שמפר תנאים אלה.</p>

    <h3>6. הרשמה, חשבונות וגישה</h3>
    <p>ככל שהאתר מציע אפשרות לפתיחת חשבון משתמש:</p>
    <ul>
      <li>עליך למסור פרטים נכונים, מדויקים ומעודכנים;</li>
      <li>עליך לשמור על סודיות פרטי ההתחברות ולא להעבירם לצדדים שלישיים;</li>
      <li>אתה נושא באחריות לכל פעולה שתעשה בחשבונך;</li>
      <li>החברה רשאית לסרב לפתוח חשבון, לסגור חשבון קיים או להגביל גישה – לפי שיקול דעתה.</li>
    </ul>

    <h3>7. שירותים בתשלום</h3>
    <ul>
      <li>ייתכן שחלק מהשירותים באתר יינתנו בתשלום (כגון: דוחות מורחבים, מנוי מקצועי, API, וכיו"ב).</li>
      <li>המחירים, תנאי התשלום ומדיניות הביטול יפורסמו באתר וישתנו מעת לעת.</li>
      <li>אם וככל שתבצע רכישה – תנאי התשלום שיופיעו בדף הרכישה יהוו חלק בלתי נפרד מתנאים אלה.</li>
      <li>החברה רשאית לשנות מחירים ותנאים, ויחולו על רכישות עתידיות בלבד, אלא אם צוין אחרת במפורש.</li>
    </ul>

    <h3>8. זכויות קניין רוחני</h3>
    <ul>
      <li>כל זכויות היוצרים, סימני המסחר, העיצובים, הקוד, מסדי הנתונים, מודלי ה-AI, הטקסטים, הגרפים והאיקונים – כולם בבעלות החברה ו/או צדדים שלישיים שהסמיכו אותה.</li>
      <li>הנתונים שמקורם במאגרים ציבוריים ו/או רשויות שייכים לגופים המפרסמים, והשימוש בהם באתר הוא לשם הצגה נוחה בלבד בהתאם לתנאים שלהם.</li>
      <li>אין להעתיק, להפיץ, לפרסם מחדש, לשדר, להציג בפומבי, לעבד או לעשות שימוש מסחרי כלשהו בתכנים ללא הסכמה מראש ובכתב מאת החברה.</li>
      <li>החברה מעניקה לך רישיון אישי, בלתי בלעדי, לא ניתן להעברה וניתן לביטול, להשתמש בשירות לצרכים פנימיים בלבד ובכפוף לתנאים אלה.</li>
    </ul>

    <h3>9. תוכן שמוזן על ידך</h3>
    <p>בעת שימושך בשירות, אתה עשוי להזין מידע ותוכן (למשל: פרטי נכס, תיאור פרויקט, הערות).</p>
    <ul>
      <li>אתה מצהיר כי יש לך את כל הזכויות הנדרשות בתוכן שאתה מזין;</li>
      <li>אתה מתחייב שהתוכן אינו מפר זכויות של צדדים שלישיים, אינו פוגעני ואינו מנוגד לדין;</li>
      <li>אתה מעניק לחברה רישיון עולמי, בלתי בלעדי ובלתי הדיר להשתמש בתוכן לצורך מתן השירות, שיפורו, ניתוחו הפנימי ויצירת תובנות סטטיסטיות (בכפוף למדיניות הפרטיות).</li>
    </ul>

    <h3>10. שימוש בבינה מלאכותית</h3>
    <p>חלק מהשירות מבוסס על מודלי בינה מלאכותית (AI) ולימוד מכונה. לכן:</p>
    <ul>
      <li>התוצרים הם תוצרי חישוב הסתברותיים ועלולים לכלול טעויות, אי-דיוקים או מידע חלקי;</li>
      <li>ייתכנו הבדלים בין תוצאות שניתנות בזמנים שונים לאותו נכס/חלקה;</li>
      <li>אין לראות בתוצרים "אמת רשמית" על הנכס או על זכויות הבנייה בו.</li>
      <li>החברה תעשה מאמץ סביר לשפר את איכות התוצרים, אך אינה מתחייבת לדיוק מלא, לשיפור מסוים או להתאמה לצרכיך הספציפיים.</li>
    </ul>

    <h3>11. אחריות והגבלת אחריות</h3>
    <p>השירות ניתן במתכונת "כפי שהוא" (AS IS) ו"כפי שהוא זמין" (AS AVAILABLE). מבלי לגרוע מכלליות האמור:</p>
    <ul>
      <li>החברה אינה מתחייבת שהשירות יהיה זמין תמיד, ללא תקלות, ללא הפרעות או ללא שגיאות.</li>
      <li>החברה אינה אחראית לכל נזק ישיר, עקיף, תוצאתי, מיוחד או עונשי הנובע משימוש בשירות או מהסתמכות על המידע בו, לרבות הפסדי רווח, אובדן הזדמנויות, הפסדי השקעה או מקורות מימון.</li>
      <li>החברה אינה אחראית לשום פעולה שתבצע (או לא תבצע) על בסיס המידע, הדוחות או ההמלצות שהתקבלו מהשירות. האחריות המלאה להחלטותיך היא עליך בלבד.</li>
      <li>החברה אינה אחראית לתוכן, לדיוק או לעדכניות מידע שמקורו בצדדי ג' (רשויות, מאגרי מידע, ספקי נתונים וכד').</li>
    </ul>

    <h3>12. שיפוי</h3>
    <p>אתה מתחייב לשפות את החברה, עובדיה, מנהליה, בעלי מניותיה וסוכניה בגין כל נזק, הפסד, תביעה, הוצאה או עלות (לרבות הוצאות משפטיות) שייגרמו להם עקב:</p>
    <ul>
      <li>הפרת תנאים אלה על ידך;</li>
      <li>שימוש בלתי חוקי או לא מורשה בשירות;</li>
      <li>הפרת זכויות צד שלישי בקשר לתוכן שהזנת.</li>
    </ul>

    <h3>13. שינוי, השעיה והפסקת השירות</h3>
    <p>החברה רשאית, בכל עת וללא הודעה מוקדמת:</p>
    <ul>
      <li>לשנות את מבנה האתר, הממשק, היכולות, התכנים או תמחור השירות;</li>
      <li>להגביל או להפסיק את פעילות השירות, כולה או חלקה;</li>
      <li>למחוק או לשנות מידע מסוים, שכבות נתונים או פיצ'רים.</li>
    </ul>
    <p>לא תהיה לך כל טענה או דרישה כנגד החברה בשל ביצוע שינויים כאמור, כל עוד תכובד כל התחייבות מפורשת כלפיך לגבי שירותים שכבר שילמת עבורם (אם רלוונטי).</p>

    <h3>14. שינוי תנאי השימוש</h3>
    <ul>
      <li>החברה רשאית לעדכן מעת לעת את תנאי השימוש. הגרסה העדכנית תמיד תפורסם באתר ותצוין עם תאריך עדכון.</li>
      <li>המשך שימושך באתר לאחר פרסום הגרסה המעודכנת יהווה הסכמה לתנאים החדשים. אם אינך מסכים/ה לשינויים – עליך להפסיק את השימוש בשירות.</li>
    </ul>

    <h3>15. דין ושיפוט</h3>
    <ul>
      <li>על תנאים אלה יחול הדין הישראלי בלבד, מבלי לתת תוקף לכללי ברירת דין בינלאומיים.</li>
      <li>סמכות השיפוט הבלעדית בכל הנוגע לתנאים אלה ולשימוש בשירות נתונה לבתי המשפט המוסמכים במחוז תל אביב-יפו.</li>
    </ul>

    <h3>16. יצירת קשר</h3>
    <p>לשאלות, הבהרות או פניות בקשר לתנאי שימוש אלה ניתן לפנות אלינו בכתובת: contact@urbanix.ai</p>
  </>
);

export const PRIVACY_POLICY = (
  <>
    <p><strong>עדכון אחרון: {new Date().toLocaleDateString('he-IL')}</strong></p>
    <p>ברוכים הבאים לאתר אורבניקס (ai.urbanix) (להלן: "האתר").</p>
    <p>מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים, שומרים ומגנים על מידע אודותיך בעת שימושך באתר ובשירותי הנדל"ן מבוססי-ה-AI שלנו (להלן: "השירות").</p>
    <p>באמצעות גלישה באתר, שימוש בשירות, או מסירת מידע דרך טפסים, אינך רק משתמש בשירות אלא גם מאשר/ת שקראת והבנת את מדיניות הפרטיות ואתה מסכים/ה לה. אם אינך מסכים/ה למדיניות זו – אנא הימנע/י משימוש באתר.</p>
    <p>הבהרה חשובה: מסמך זה הוא נוסח כללי לדוגמה ואינו מהווה ייעוץ משפטי. מומלץ להתייעץ עם עו״ד לפני אימוץ סופי.</p>

    <h3>1. מי אנחנו</h3>
    <p>המונחים "אנו", "אנחנו" או "אורבניקס" מתייחסים למפעילי האתר והשירות ai.urbanix (להלן: "החברה").</p>
    <p>החברה מפעילה פלטפורמת מידע וניתוח נדל"ני שמרכזת מידע מבוזר על נכסים, חלקות וקרקעות בישראל, מציגה אותו בצורה פשוטה ונגישה, ומספקת תובנות וניתוחים באמצעות טכנולוגיות בינה מלאכותית.</p>
    <p>ליצירת קשר בנושאי פרטיות ניתן לפנות לכתובת הדוא"ל: contact@urbanix.ai</p>

    <h3>2. איזה מידע אנחנו אוספים</h3>
    <p>אנו עשויים לאסוף את סוגי המידע הבאים:</p>
    
    <h4>2.1 מידע שנמסר על ידך</h4>
    <ul>
      <li>פרטי קשר שאתה מזין באופן יזום, כגון: שם מלא, דוא"ל, טלפון, תפקיד, שם חברה.</li>
      <li>מידע שמוזן בטפסי יצירת קשר, הרשמה, הצטרפות לרשימת תפוצה, בקשת דוח נדל"ן, הערות חופשיות וכדומה.</li>
      <li>פרטי התחברות לחשבון משתמש, אם וככל שתהליך הרשמה יופעל באתר (שם משתמש, סיסמה מוצפנת וכו').</li>
    </ul>

    <h4>2.2 מידע על שימושך באתר</h4>
    <p>בעת שימושך באתר אנו עשויים לאסוף באופן אוטומטי:</p>
    <ul>
      <li>נתוני שימוש טכניים: סוג דפדפן, מערכת הפעלה, שפת ממשק, זמן ביקור, עמודים שנצפו, כתובת IP (בקירוב גיאוגרפי בלבד).</li>
      <li>נתוני לוג: פעולות שבוצעו באתר (למשל: צפייה בדוחות, חיפוש כתובת/חלקה, לחיצה על כפתורים מסוימים), שגיאות מערכת וכדומה.</li>
      <li>מידע סטטיסטי ואנליטי לגבי שימוש כולל בשירות, ללא זיהוי אישי ישיר (לאחר אנונימיזציה או פסאודונימיזציה).</li>
    </ul>

    <h4>2.3 מידע על נכסים, חלקות וקרקעות</h4>
    <p>במסגרת השימוש בשירות, אתה עשוי להזין:</p>
    <ul>
      <li>כתובות, מספרי חלקה/גוש, פרטי נכס, פרטי מבנה או פרויקטים (כגון: פינוי-בינוי, תמ״א, פרטי זכויות ידועות וכד').</li>
      <li>העדפות ונתונים לצורך ניתוח (למשל: "פליפ", השקעה, התחדשות עירונית, מגורים, מסחרי וכו').</li>
    </ul>
    <p>לצד המידע שאתה מזין, אנו עשויים לשייך לאותם נכסים גם מידע שנאסף ממקורות ציבוריים או מספקי נתונים צד שלישי.</p>

    <h4>2.4 מידע ממקורות חיצוניים וציבוריים</h4>
    <p>אורבניקס מרכזת "שכבת נגישות" על גבי מידע מבוזר. לכן אנו עשויים לעשות שימוש בנתונים שמקורם:</p>
    <ul>
      <li>במאגרים ציבוריים ו/או ממשלתיים (למשל: מערכות GIS, מידע סטטוטורי, תכניות בניין עיר, נתוני ארנונה/ייעודי קרקע כפי שמפורסמים לציבור וכו');</li>
      <li>בספקי מידע פרטיים המשתפים עמנו מידע על פרויקטים, מחירי נכסים, מאגרי עסקאות וכיו"ב;</li>
      <li>במערכות אנליטיקה ובינה מלאכותית לצורך עיבוד, ניתוח וסיווג מידע.</li>
    </ul>
    <p>שימוש במידע זה מתבצע בהתאם לתנאי המאגרים הרלוונטיים ולדין החל.</p>

    <h3>3. מטרות השימוש במידע</h3>
    <p>אנו משתמשים במידע למטרות הבאות:</p>
    <ul>
      <li><strong>מתן השירות</strong>
        <ul>
          <li>הפקת דוחות נדל"ן, ניתוחי פוטנציאל, אינדיקציות להתחדשות עירונית, הערכות "פליפ" ושירותי ייעוץ-AI נוספים.</li>
          <li>התאמת תוכן ותצוגה למיקום ולצרכים שלך (למשל: הצגת שכבות נתונים רלוונטיות).</li>
        </ul>
      </li>
      <li><strong>שיפור ופיתוח השירות</strong>
        <ul>
          <li>ניתוח דפוסי שימוש לשיפור חוויית המשתמש, איכות התחזיות והדיוק של אלגוריתמי ה-AI.</li>
          <li>איתור תקלות, מדידת ביצועים, פיתוח פיצ'רים חדשים.</li>
        </ul>
      </li>
      <li><strong>תקשורת אתך</strong>
        <ul>
          <li>מענה לפניות, שליחת עדכונים לגבי בקשות ששלחת, תמיכה טכנית.</li>
          <li>שליחת חומרי תוכן שיווקיים/מקצועיים ומידע על שירותים חדשים, בכפוף להסכמה ובהתאם לחוק.</li>
        </ul>
      </li>
      <li><strong>ציות לדין והגנה על זכויות</strong>
        <ul>
          <li>עמידה בדרישות חוק ורשויות מוסמכות.</li>
          <li>מניעת הונאה, שימוש לרעה, פגיעה בשירות או בצדדים שלישיים.</li>
        </ul>
      </li>
    </ul>

    <h3>4. שיתוף מידע עם צדדים שלישיים</h3>
    <p>אנו לא מוכרים מידע אישי לצדדים שלישיים לצורכי שיווק שלהם. יחד זאת, ייתכן שנשתף מידע במקרים הבאים:</p>
    <ul>
      <li><strong>ספקי שירות מטעמנו</strong>: חברות אחסון ענן, אבטחת מידע, אנליטיקה, שירותי דוא"ל, מערכות CRM ובינה מלאכותית. שיתוף המידע נעשה רק במידה הנדרשת לצורך מתן השירות, ובהסכמים שמחייבים הגנת פרטיות.</li>
      <li><strong>שותפים מקצועיים</strong>: ככל ששיתוף מסוים דרוש לצורך הפקת שירות פרטני (למשל: שמאי, יועץ מיסוי, עו"ד, אדריכל), נעשה זאת רק בכפוף להסכמתך הספציפית, אם נדרשת.</li>
      <li><strong>מקרים משפטיים</strong>: אם החוק מחייב אותנו, או אם שיתוף המידע נחוץ לצורך הגנה על זכויותינו המשפטיות, מניעת עבירות או הגנה על צדדים שלישיים.</li>
      <li><strong>העברת פעילות עסקית</strong>: במקרה של מיזוג, רכישה, מכירת פעילות או שינוי שליטה בחברה – המידע עשוי לעבור לצד הרוכש, בכפוף להמשך שמירה על מדיניות פרטיות זו או דומה לה.</li>
      <li><strong>מידע מצרפי ואנונימי</strong>: אנו עשויים לפרסם או לשתף מידע סטטיסטי שלא מזהה אותך אישית (למשל: הפקת דוחות על מגמות שוק).</li>
    </ul>

    <h3>5. Cookies וטכנולוגיות דומות</h3>
    <p>האתר עשוי להשתמש בעוגיות (Cookies) ובטכנולוגיות מעקב דומות לצורך:</p>
    <ul>
      <li>תפקוד תקין של האתר;</li>
      <li>שמירת העדפות (שפה, הגדרות תצוגה וכד');</li>
      <li>ניתוח שימוש (אנליטיקה);</li>
      <li>התאמת תוכן שיווקי (רימרקטינג), בכפוף לדין.</li>
    </ul>
    <p>באפשרותך להגדיר את הדפדפן לחסום או למחוק Cookies, אך ייתכן שחלק מהשירותים לא יעבדו בצורה מיטבית.</p>

    <h3>6. אבטחת מידע</h3>
    <p>אנו מיישמים אמצעים סבירים ומקובלים להגנה על המידע מפני גישה לא מורשית, שימוש לרעה או חשיפה. עם זאת, אין מערכת אבטחה מושלמת, ואיננו יכולים להתחייב לחסינות מוחלטת מפני חדירות או כשלים.</p>

    <h3>7. שמירת מידע</h3>
    <p>נשמור מידע אישי למשך הזמן הדרוש כדי:</p>
    <ul>
      <li>לספק את השירות;</li>
      <li>לעמוד בדרישות הדין (למשל שמירת רישומים);</li>
      <li>להגן על זכויותינו המשפטיות.</li>
    </ul>
    <p>מידע שאינו נחוץ עוד יימחק או יעבור תהליך אנונימיזציה, ככל שהדבר אפשרי.</p>

    <h3>8. הזכויות שלך</h3>
    <p>בכפוף לדין החל (לרבות הדין הישראלי ו/או דיני פרטיות זרים ככל שיחולו), ייתכן שאתה זכאי לבקש:</p>
    <ul>
      <li>עיון במידע האישי אודותיך;</li>
      <li>תיקון מידע שגוי או לא מעודכן;</li>
      <li>מחיקה של מידע, במקרים מסוימים ("הזכות להישכח");</li>
      <li>הגבלת עיבוד;</li>
      <li>התנגדות לשימוש מסוים (למשל שיווק ישיר);</li>
      <li>העתק של המידע בפורמט נייד, ככל שמתקיים תנאי הדין.</li>
    </ul>
    <p>למימוש זכויותיך ניתן לפנות אלינו בדוא"ל המופיע לעיל. ייתכן שנבקש אמצעי זיהוי ופרטים נוספים לצורך טיפול בבקשה, ונפעל תוך פרק זמן סביר ובהתאם לדין.</p>

    <h3>9. העברת מידע מחוץ לישראל</h3>
    <p>ייתכן שמידע יאוחסן או יעובד בשרתים הממוקמים מחוץ לישראל. אנו נפעל כדי לוודא שרמת ההגנה על פרטיותך תהיה סבירה ומקובלת, בין היתר באמצעות חוזים מתאימים עם ספקי השירות.</p>

    <h3>10. קישורים ושירותי צד שלישי</h3>
    <p>האתר עשוי להכיל קישורים או ממשקים לשירותים אחרים (למשל: אתרי רשויות מקומיות, מאגרי מידע ממשלתיים, אתרי בני ברית עסקיים). מדיניות פרטיות זו אינה חלה על שירותים אלו; מומלץ לקרוא את מדיניות הפרטיות שלהם בנפרד.</p>

    <h3>11. קטינים</h3>
    <p>השירות אינו מיועד לקטינים מתחת לגיל 18. איננו אוספים ביודעין מידע מקטינים. אם נודע לך כי קטין מסר לנו מידע בניגוד למדיניות זו, אנא פנה אלינו כדי שנוכל להסיר את המידע.</p>

    <h3>12. שינויים במדיניות</h3>
    <p>אנו רשאים לעדכן מעת לעת את מדיניות הפרטיות. כאשר יבוצעו שינויים מהותיים, נעשה מאמץ סביר להבליט זאת באתר. המשך שימושך באתר לאחר העדכון יהווה הסכמה למדיניות המעודכנת.</p>

    <h3>13. יצירת קשר</h3>
    <p>לשאלות, בקשות או הערות בנוגע למדיניות פרטיות זו, ניתן לפנות אלינו בדוא"ל: contact@urbanix.ai</p>
  </>
);

export const ACCESSIBILITY_STATEMENT = (
  <>
    <p><strong>עדכון אחרון: {new Date().toLocaleDateString('he-IL')}</strong></p>
    
    <h3>מחויבות לנגישות</h3>
    <p>אורבניקס מחויבת להנגיש את האתר והשירותים שלה לכלל האוכלוסייה, לרבות אנשים עם מוגבלויות. אנו פועלים להנגשת האתר בהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע"ג-2013 ובהתאם לתקן הישראלי ת"י 5568 ברמת AA.</p>

    <h3>פעולות שבוצעו להנגשת האתר</h3>
    <p>במסגרת מאמצינו להנגשה, ביצענו את הפעולות הבאות:</p>
    <ul>
      <li>התאמת האתר לגלישה באמצעות קורא מסך;</li>
      <li>התאמת האתר לניווט באמצעות מקלדת;</li>
      <li>שימוש בניגודיות צבעים מספקת;</li>
      <li>הוספת תיאורי טקסט חלופי לתמונות;</li>
      <li>מבנה כותרות היררכי וסמנטי;</li>
      <li>טפסים נגישים עם תיוג מתאים;</li>
      <li>קישורים ברורים ומתארים.</li>
    </ul>

    <h3>טכנולוגיות נתמכות</h3>
    <p>האתר תומך בגלישה באמצעות הדפדפנים הנפוצים בגרסאותיהם העדכניות:</p>
    <ul>
      <li>Google Chrome</li>
      <li>Mozilla Firefox</li>
      <li>Apple Safari</li>
      <li>Microsoft Edge</li>
    </ul>
    <p>האתר מותאם לשימוש עם קוראי מסך כגון NVDA, JAWS ו-VoiceOver.</p>

    <h3>הסדרי נגישות במשרדי החברה</h3>
    <p>משרדי החברה נגישים לאנשים עם מוגבלות פיזית, לרבות:</p>
    <ul>
      <li>חניית נכים בסמוך לכניסה;</li>
      <li>כניסה נגישה ללא מדרגות;</li>
      <li>שירותים נגישים.</li>
    </ul>

    <h3>דרכי פנייה לבקשות והצעות לשיפור</h3>
    <p>אם נתקלתם בבעיית נגישות באתר, או אם יש לכם הצעות לשיפור הנגישות, נשמח לשמוע מכם:</p>
    <ul>
      <li><strong>רכז נגישות:</strong> צוות אורבניקס</li>
      <li><strong>דוא"ל:</strong> contact@urbanix.ai</li>
    </ul>

    <h3>תאריך עדכון הצהרת הנגישות</h3>
    <p>הצהרה זו עודכנה לאחרונה בתאריך {new Date().toLocaleDateString('he-IL')}.</p>
    <p>אנו ממשיכים לפעול לשיפור נגישות האתר באופן שוטף.</p>
  </>
);

